import { setContext } from '@apollo/client/link/context'
import getConfig from 'next/config'
import parse from 'url-parse'
import { getLocaleByDomain } from '~/utils/localization'

const { TOKEN_COOKIE_NAME, API_URL } = getConfig().publicRuntimeConfig
const { host } = parse(API_URL)

const headersLink = context => {
  return setContext((_graphQLRequest, prevContext) => {
    const token = context?.req
      ? context.req.cookies[TOKEN_COOKIE_NAME]
      : document.cookie
          .split('; ')
          .find(row => row.startsWith('token='))
          ?.split('=')[1]
    const localeFromHostname = context?.locale ?? getLocaleByDomain(window.location.hostname)

    return {
      headers: {
        ...prevContext.headers,
        Authorization: token ? `Bearer ${token}` : '',
        ...(context?.req?.headers['user-agent'] && {
          'user-agent': context.req.headers['user-agent'],
        }),
        ...(context?.req?.headers['x-forwarded-for'] && {
          'x-forwarded-for': context.req.headers['x-forwarded-for'],
        }),
        ...(context?.req?.headers['x-forwarded-port'] && {
          'x-forwarded-port': context.req.headers['x-forwarded-port'],
        }),
        ...(context?.req?.headers['x-forwarded-proto'] && {
          'x-forwarded-proto': context.req.headers['x-forwarded-proto'],
        }),
        ...(localeFromHostname && {
          'accept-language': localeFromHostname,
        }),
        host,
      },
    }
  })
}

export default headersLink
